var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-list-product-items"},[_c('ul',_vm._l((_vm.items),function(ref){
var item = ref.item;
return _c('li',{key:item.id,staticClass:"mb-2"},[_c('div',{staticClass:"product-item-name",domProps:{"innerHTML":_vm._s(item.name)}}),_c('div',{staticClass:"product-item-description small mb-3",domProps:{"innerHTML":_vm._s(item.description)}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }